module.exports = __webpack_public_path__ + "img/ruoyi6.c20f04d1.png";